import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { BackednResponse } from "@shared/lib/types";
import { IValidateReportCsvResponse } from "@shared/lib/types/reports";
import { ReportService } from "../services/Report.servie";

export function useValidateReportCsv() {
  const {
    mutate: validateReportCsv,
    isLoading: isValidating,
    isSuccess: isValidated,
    data,
    isError,
    error,
  } = useMutation<string, BackednResponse<IValidateReportCsvResponse[]>>({
    mutationFn: (csvLink: string) =>
      ReportService.validateReportCsv(csvLink).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }),
    options: {
      skipInvalidation: true,
    },
  });

  return {
    validateReportCsv,
    isValidating,
    isValidated,
    data,
    isError,
    error,
  };
}
